export default __webpack_public_path__ + "static/iig-1dc9b70e83879f0fb1d8465eaab5191a.jpg";